/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

const IconLinkItem = (props) => {

    const iconLink = props?.iconLink;
    const iconUrl = iconLink?.icon;
    const link = iconLink?.link;
    const linkUrl = link?.url;
    const linkText = link?.text;

    return (
        <a className="icon-link-item" href={linkUrl}>
            <div className="icon-link-item-content">
                <img alt='icon' src={iconUrl} />
                <span className="icon-link-item-text">{linkText}</span>
            </div>
        </a>
    );
};

IconLinkItem.displayName = "IconLinkItem";
export { IconLinkItem }; 